import { render, staticRenderFns } from "./Spacecrabs.vue?vue&type=template&id=4208a27d&scoped=true&"
var script = {}
import style0 from "./Spacecrabs.vue?vue&type=style&index=0&id=4208a27d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4208a27d",
  null
  
)

export default component.exports